// src/api/axiosInstance.js
import axios from "axios";

const instance = axios.create({
  baseURL: "https://questa.mb-techs.com/questa/v1", // Change only this when deploying
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;